module.exports = "/images/vendor/desiigner-svg/svg/ui/zoom-in.svg?998ed7f259cd46e6c118e210d21044bb";